var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'd-none': _vm.$route.path !== '/paid-services' },attrs:{"id":"widget-container"}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floating"},[_c('button',{staticClass:"floating-action-button my-awesome-button text-circe-14",attrs:{"data-widget":"appointment-widget"}},[_vm._v("Записаться к врачу ")])])
}]

export { render, staticRenderFns }